export default __webpack_public_path__ + "static/media/img-3.c0f9a305.jpg";